import React, { useEffect, useState } from 'react';
import { View } from '../../src/Components/Themed';
import Campaign from '../../src/Campaign';
import { APIOverrides } from 'be-components';


type CampaignAppProps = {
    campaign_id:string,
    ad_url?:string,
    color_mode?:'light'|'dark'
}


const CampaignApp = ({ campaign_id }:CampaignAppProps) => {
    const [ auth_state, setAuthState ] = useState<any>({})
    
    useEffect(() => {
        if(!campaign_id){ return }
        startUp();
    },[campaign_id]);



    const startUp = async() => {
        const auth_state = await APIOverrides.start({
            env: 'PRODUCTION',
            no_cache: false
        });
        setAuthState(auth_state);
    }

    return (
        <View style={{ flex:1 }}>
            <Campaign
                campaign_id={campaign_id}
                auto={true}
                onSelectCompetition={() => console.log('')}
                onSelectPollCampaign={() => console.log('')}
                distinct_id={auth_state.distinct_id}
            />
        </View>
    )
}

export default CampaignApp


/*
<View style={{ flex:1, flexDirection:'row' }}>
                <View>
                
                <View style={{ flexDirection:'row' }}>
                   
                    
                </View>
                </View>
                
            </View>

*/